"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AlertIcon_1 = require("../../Icons/Assets/AlertIcon");
var ErrorLabel_styles_1 = require("./ErrorLabel.styles");
exports.default = (function (_a) {
    var HideIcon = _a.HideIcon, ID = _a.ID, children = _a.children;
    return (React.createElement(ErrorLabel_styles_1.LabelContainer, null,
        !HideIcon && React.createElement(ErrorLabel_styles_1.IconContainer, null,
            React.createElement(AlertIcon_1.AlertIcon, { Width: "18px", Height: "18px" })),
        React.createElement(ErrorLabel_styles_1.StyledLabel, { "aria-live": "assertive", id: ID, role: "alert" }, children)));
});
